import { Row } from "components/styles";
import {
	Container,
	DividerTitle,
	Subtitle,
	Title,
} from "views/components/AttendanceList/TakeTeacherAttendancePanel/styles";
import attendedIcon from "img/attended_icon.svg";

/*
NOTA: Captura de hora de salida prepara por si se requiere en un futuro.
*/
const TeacherAttendanceClassDetail = ({
	teacherName,
	dataTeacherAttendance,
}) => {
	const {
		checkInTime,
		// checkOutTime,
		// classTime,
	} = dataTeacherAttendance;
	return (
		<Container
			direction="column"
			align="flex-start"
		>
			<Subtitle>Detalle de clase</Subtitle>
			<Row>
				<img
					src={attendedIcon}
					alt="Ícono de asistió"
				/>
				<Row gap="25px">
					<Title>
						Docente: <strong>{teacherName}</strong>
					</Title>
					<DividerTitle>|</DividerTitle>
					<Title>
						Tu hora de entrada: <strong>{checkInTime}</strong>
					</Title>
					{/* <DividerTitle>|</DividerTitle>
					<Title>
						Tu hora de salida: <strong>{checkOutTime}</strong>
					</Title> */}
					{/* <DividerTitle>|</DividerTitle>
					<Title>
						Tiempo de clase: <strong>{classTime}</strong>
					</Title> */}
				</Row>
			</Row>
		</Container>
	);
};

export default TeacherAttendanceClassDetail;
